import { Button, Input } from 'antd';
import * as React from "react";
import "./CopyTextInput.scss";

export function CopyTextInput(props: { value: string }) {
    return (
        <>
            <Input
                id="copy-text-input"
                type="text"
                value={props.value}
                disabled
            />
            <Button onClick={() => navigator.clipboard.writeText(props.value)} >Copiar</Button>
        </>
    )
}



// WEBPACK FOOTER //
// ./src/components/common/CopyTextInput/CopyTextInput.tsx